import 'utils/handler';
require('dotenv').config();
export const salesMail = 'sales@saw.com';
const google_client_secret = 's1TOT8VhdGMqaEq0Cin4hc5S';
let google_client_id = '334759244504-05pqdr6i5cp93nbspu2mvs4ss44beaal.apps.googleusercontent.com';
const linkedIn_client_id = '86l7viptt5odrt';
const linkedIn_client_secret = 'qbX3NyZ65ad9Dim0';
let linkedInScope = 'r_emailaddress+r_liteprofile';

let baseUrl = 'https://prod-api.saw.com';
let redirect_URL = 'https://buy.saw.com';
let saw_URL = 'https://saw.com';
let sampleRegistrarUID = 'b7e9d2e9-2d7c-45f5-9a1c-b417802f9585'; //"280985bf-4ef4-4b0d-954f-f2f2fbe3fb91"
const baseImageUrl = baseUrl + '/assets/';
export const encryptAddOn = '3n0s3';
let stripeLiveKey = 'pk_test_51Is6mVHlXYKcUGnRRKWgZ4KqLeyk75qOPlgpRIvduSwOzIetAbOl2d9MERSzp7K0HIXGlEPbV0at9glO4orhqujs00ECbGGAAU';
export const sessionExpiryMinute = 60;
google_client_id = process.env.REACT_APP_google_client_id || google_client_id;
baseUrl = process.env.REACT_APP_baseUrl || baseUrl;
redirect_URL = process.env.REACT_APP_redirect_URL || redirect_URL;
saw_URL = process.env.REACT_APP_saw_URL || saw_URL;
stripeLiveKey = process.env.REACT_APP_stripeLiveKey || stripeLiveKey;
const initialAmount = 19.95;
const requestHeader = {
  headers: {
    Authorization: localStorage.getItem('saw-token') || 'Token',
  },
};
export const formNames = {
  appraisalBuy: 'Appraisal Buy',
  appraisalSell: 'Appraisal Sell',
  defaultForm: 'Buy a Domain Name',
};
export { baseImageUrl, baseUrl, google_client_id, google_client_secret, initialAmount, linkedInScope, linkedIn_client_id, linkedIn_client_secret, redirect_URL, saw_URL, requestHeader, sampleRegistrarUID, stripeLiveKey };

export const botActions = {
  appraisal: 'Appraisal',
};
export const paymentStatusTypes = {
  success: 'succeeded',
  failed: 'failed',
  refunded: 'refunded',
  actionRequired: 'requires_action',
  authRequired: 'Further Authorization Required',
};
